import { ActionFunction } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// GQL
import { client } from '../../../gql/client';
import { FORGOT_PASSWORD } from '../../../gql/mutations/auth';

// Utils
import { showSuccessToast } from '../../../utils/toasts';
import i18n from '../../../i18n';

export const ActionForgotPassword: ActionFunction = async (formDataRaw) => {
  const formData = Object.fromEntries(await formDataRaw.request.formData());

  try {
    await client.mutate({
      mutation: FORGOT_PASSWORD,
      variables: {
        input: {
          email: formData.email,
        },
      },
    });

    // Always show success toast for security reasons
    // (don't reveal if email exists or not)
    showSuccessToast(i18n.t('auth:forgotPassword.successMessage'));

    return null;
  } catch (err) {
    Sentry.captureException(err);
    console.log('Error', err);

    // For security, still show success toast even on error
    showSuccessToast(i18n.t('auth:forgotPassword.successMessage'));

    return null;
  }
};
